import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { getTeamColors } from '@/utils/teamColors';

interface ESPNAthlete {
  id: string;
  name: string;
  display_name?: string;
  first_name?: string;
  sport: string;
  league?: string;
  position?: string;
  current_team_name?: string;
  headshot_url?: string;
  [key: string]: any;
}

interface AthleteCompactViewProps {
  athletes: ESPNAthlete[];
  onAthleteClick: (athlete: ESPNAthlete) => void;
  isCollegiate?: boolean;
  collegiateSportsDisplay?: Record<string, string>;
}

export const AthleteCompactView: React.FC<AthleteCompactViewProps> = ({
  athletes,
  onAthleteClick,
  isCollegiate = false,
  collegiateSportsDisplay = {},
}) => {
  return (
    <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-8 gap-4">
      {athletes.map((athlete) => {
        const teamColors = getTeamColors(athlete.current_team_name || '', isCollegiate ? 'college' : (athlete.league || ''));
        return (
          <div
            key={athlete.id}
            className="flex flex-col items-center gap-2 p-3 rounded-lg hover:bg-muted/50 cursor-pointer transition-colors"
            onClick={() => onAthleteClick(athlete)}
          >
            <Avatar className="h-16 w-16">
              <AvatarImage src={athlete.headshot_url || ''} className="object-cover" />
              <AvatarFallback
                className="text-lg text-white font-bold"
                style={{ background: `linear-gradient(135deg, ${teamColors.primary} 0%, ${teamColors.secondary} 100%)` }}
              >
                {athlete.first_name?.[0] || athlete.name[0]}
              </AvatarFallback>
            </Avatar>
            <div className="text-center min-w-0 w-full">
              <p className="text-sm font-medium truncate">{athlete.display_name || athlete.name}</p>
              <p className="text-xs text-muted-foreground truncate">
                {isCollegiate ? (collegiateSportsDisplay[athlete.sport] || athlete.sport) : (athlete.league || athlete.sport).toUpperCase()}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
